import { render, staticRenderFns } from "./ManageTeam.vue?vue&type=template&id=0ecdd6fa&scoped=true&"
import script from "./ManageTeam.vue?vue&type=script&lang=js&"
export * from "./ManageTeam.vue?vue&type=script&lang=js&"
import style0 from "./ManageTeam.vue?vue&type=style&index=0&id=0ecdd6fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecdd6fa",
  null
  
)

export default component.exports